import { useQuery } from "@jti/rest-api";

import { magento } from "../../clients/getClient";

export const useStoreConfig = () =>
  useQuery({
    queryKey: ["GET_STORE_CONFIG"],
    queryFn: () => magento.getStoreConfig(),
    staleTime: 1000 * 60 * 5,
  });
